/* ==========================================================================
   InstaCuppa PDP — Amazon ratings/reviews behavior (2026-06-22)
   - tune the amazon-product-rating (hide social proof, larger stars, clickable)
   - relocate amazon-product-reviews into the Reviews tab (desktop + mobile)
   - clicking the rating opens the Reviews tab and scrolls to it
   Loaded only on product templates.
   ========================================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

  function reviewsIndex() {
    var btns = document.querySelectorAll('.tabs-nav .tab-button[data-tab-index]');
    for (var i = 0; i < btns.length; i++) if (/review/i.test(btns[i].textContent)) return btns[i].getAttribute('data-tab-index');
    var hs = document.querySelectorAll('[data-accordion-header][data-accordion-index]');
    for (var j = 0; j < hs.length; j++) if (/review/i.test(hs[j].textContent)) return hs[j].getAttribute('data-accordion-index');
    return null;
  }

  function openReviews() {
    var idx = reviewsIndex(); if (idx == null) return; var anchor;
    if (isMobile()) {
      var hs = document.querySelectorAll('[data-accordion-header][data-accordion-index]');
      var h = hs[parseInt(idx, 10)]; if (h && !h.classList.contains('active')) h.click();
      anchor = (h && h.closest('.accordion-item')) || document.querySelector('.tabs-accordion');
    } else {
      var btn = document.querySelector('.tabs-nav .tab-button[data-tab-index="' + idx + '"]'); if (btn) btn.click();
      anchor = document.querySelector('.tabs-section-wrapper');
    }
    setTimeout(function () { if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 480);
  }

  /* tune the rating element ASAP: hide 700+ social proof, larger stars, click->tab */
  function tuneRating() {
    document.querySelectorAll('amazon-product-rating').forEach(function (el) {
      if (el.getAttribute('show-social-proofing') !== 'false') el.setAttribute('show-social-proofing', 'false');
      if (el.getAttribute('star-size') !== 'large') el.setAttribute('star-size', 'large');
      // move it to sit directly under the product title (BWA injects it lower in the column)
      var title = document.querySelector('.product__info-container .product__title');
      if (title && title.nextElementSibling !== el && !el.closest('.t2-stars')) title.insertAdjacentElement('afterend', el); // CX Test 2: B keeps it in the .t2-stars slot
      if (!el.__croClick) { el.__croClick = true; el.style.cursor = 'pointer'; el.addEventListener('click', function (e) { e.preventDefault(); openReviews(); }); }
    });
  }
  // CX 2026-10-02: coalesce mutations to one tuneRating per frame (was: every mutation)
  var __tq = false;
  try { new MutationObserver(function () { if (__tq) return; __tq = true; requestAnimationFrame(function () { __tq = false; tuneRating(); }); }).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  document.addEventListener('DOMContentLoaded', tuneRating); tuneRating();

  /* relocate amazon-product-reviews into the visible Reviews-tab slot */
  var origSec = null;
  function relocate() {
    var w = document.querySelector('amazon-product-reviews'); if (!w) return false;
    if (!origSec && !w.closest('.amz-reviews-slot')) origSec = w.closest('.shopify-section') || w.parentElement;
    var idx = reviewsIndex(); if (idx == null) return false;
    var dp = document.querySelector('.tabs-content .tab-content[data-content-index="' + idx + '"]');
    var desktop = dp ? dp.querySelector('.amz-reviews-slot') : null;
    var bodies = document.querySelectorAll('.tabs-accordion [data-accordion-body]');
    var mp = bodies[parseInt(idx, 10)]; var mobile = mp ? mp.querySelector('.amz-reviews-slot') : null;
    var target = isMobile() ? mobile : desktop; if (!target) return false;
    if (w.parentNode !== target) target.appendChild(w);
    var inner = target.parentElement; if (inner) inner.querySelectorAll(':scope > p').forEach(function (p) { if (!p.textContent.trim()) p.remove(); });
    if (origSec && origSec !== target.closest('.shopify-section')) origSec.classList.add('amz-reviews-relocated-source');
    return true;
  }
  // run both every tick for ~24s so we reliably catch BWA's (late, racey) injection
  var t = 0, ok = 0, iv = setInterval(function () { t++; tuneRating(); ok = relocate() ? ok + 1 : 0; if (t > 60 || ok >= 5) clearInterval(iv); }, 400); // CX 2026-10-02: stop after 5 consecutive successful ticks
  window.addEventListener('resize', function () { clearTimeout(window.__amzRz); window.__amzRz = setTimeout(relocate, 200); });
})();

/* ==========================================================================
   BWA delivery fix (2026-06-22): Amazon's delivery iframe gets sized (e.g. 127px)
   but its #bwa-delivery-block-container is often left display:none on mobile
   (timing race in BWA's own decide logic), so neither Amazon delivery NOR our
   fallback timer shows. This forces the container visible when the iframe has
   real height; if Amazon truly has no delivery content, reveal our 7-day timer.
   Mutually exclusive each tick → never both. Desktop already works → no-op there.
   ========================================================================== */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  // Amazon-style "Delivered by [date]" line for products with NO Buy-with-Amazon delivery.
  // Same look/position as Amazon's (minus the logo); date = today + 7 days.
  function fallbackDateStr() {
    // non-Amazon delivery estimate: always 7 days (IST date so it's correct for IN shoppers)
    var ist = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
    ist.setDate(ist.getDate() + 7);
    return ist.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  }
  function showFallbackDelivery(timer) {
    if (document.querySelector('.cro-fallback-delivery')) return;
    var anchor = timer || document.querySelector('#cro-urgency, .product-form');
    if (!anchor) return;
    var el = document.createElement('div');
    el.className = 'cro-fallback-delivery';
    el.innerHTML = 'Delivered by <strong>' + fallbackDateStr() + '</strong>';
    anchor.parentNode.insertBefore(el, anchor);
    if (timer) timer.style.setProperty('display', 'none', 'important'); // hide verbose countdown
  }

  var n = 0;
  var iv = setInterval(function () {
    n++;
    var ifr = document.querySelector('#bwa-delivery-block-iframe');
    var cont = document.querySelector('#bwa-delivery-block-container');
    var timer = document.querySelector('#cro-urgency-wrap');
    var h = ifr ? (parseInt(ifr.style.height, 10) || ifr.offsetHeight || 0) : 0;
    if (cont && h > 10) {
      document.querySelectorAll('.cro-fallback-delivery').forEach(function (x) { x.remove(); }); // CX 2026-10-11: Amazon wins over the fallback line
      if (getComputedStyle(cont).display === 'none') cont.style.setProperty('display', 'block', 'important');
      var pa = cont.parentElement;
      if (pa && getComputedStyle(pa).display === 'none') pa.style.setProperty('display', 'block', 'important');
      if (timer && getComputedStyle(timer).display !== 'none') timer.style.setProperty('display', 'none', 'important');
      // Mobile: widen the iframe so Amazon reflows the delivery onto ONE line (date +
      // pincode). The width CHANGE is what triggers the reflow — must be set in JS, not
      // CSS. CSS then scales it (0.70) back down to fit. Only when it's still narrow.
      if (window.matchMedia('(max-width: 749px)').matches && ifr && ifr.offsetWidth < 550) {
        ifr.style.setProperty('width', '560px', 'important');
        ifr.style.setProperty('min-width', '560px', 'important');
      }
    } else if (n >= 18) {
      // no Amazon delivery → show our Amazon-style "Delivered by [date]" line (no logo)
      showFallbackDelivery(timer);
    }
    if (cont && h > 10) window.__croDelOk = (window.__croDelOk || 0) + 1;
    if (n > 25 || window.__croDelOk >= 5) clearInterval(iv); // CX 2026-10-02: stop once Amazon delivery is stable
  }, 400);
})();
